import React from 'react';
import Typography from '@src/new-components/Typography';
import EmptyVoiceImage from '@src/assets/images/empty-project.svg';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import { StyledEmptyWithdrawalRequest } from './index.style';

const EmptyWithdrawalRequest = ({ description, isDescription }) => {
  const { t } = useTranslation();

  return (
    <StyledEmptyWithdrawalRequest>
      <img
        src={EmptyVoiceImage}
        alt="Empty box"
        className="empty-voice-image"
      />
      {isDescription && (
        <Typography
          variant="body-14-medium"
          sx={{ textAlign: 'center', color: COLOR.label2[64] }}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(t(description), {
              allowedTags: ['br'],
            }),
          }}
        />
      )}
    </StyledEmptyWithdrawalRequest>
  );
};

export default EmptyWithdrawalRequest;
